import React from 'react';
import { Calendar, FileText, CalendarDays, AlertTriangle, Users, Link, Mail } from 'lucide-react';
export function QuickServices() {
  const services = [{
    title: 'Próxima reunión',
    desc: 'Consulta los detalles de la próxima reunión comunitaria.',
    icon: Calendar
  }, {
    title: 'Agendas y minutas',
    desc: 'Revisa documentos oficiales, temas discutidos y decisiones anteriores.',
    icon: FileText
  }, {
    title: 'Calendario',
    desc: 'Encuentra reuniones, eventos, fechas importantes y actividades comunitarias.',
    icon: CalendarDays
  }, {
    title: 'Reportar un problema',
    desc: 'Accede a canales como MyLA311 u otros recursos oficiales para reportes locales.',
    icon: AlertTriangle
  }, {
    title: 'Comités',
    desc: 'Conoce los grupos de trabajo, sus temas y formas de participación.',
    icon: Users
  }, {
    title: 'Recursos comunitarios',
    desc: 'Encuentra enlaces útiles para familias, adultos mayores, jóvenes, vivienda, servicios y apoyo local.',
    icon: Link
  }, {
    title: 'Contacto oficial',
    desc: 'Comunícate con el comité para preguntas, comentarios o solicitudes.',
    icon: Mail
  }];
  return <section className="py-24 px-6 lg:px-8 bg-softblue" data-id="element-420">
      <div className="max-w-6xl mx-auto" data-id="element-421">
        <div className="mb-12" data-id="element-422">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-423">
            Servicios Rápidos
          </h2>
          <p className="text-xl text-gray-600" data-id="element-424">
            Encuentra lo que necesitas sin buscar en todo el sitio.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-425">
          {services.map((service, index) => <a href="#" key={index} className="flex items-start gap-4 p-5 bg-white rounded-xl border border-gray-100 hover:border-sky hover:shadow-md transition-all group" data-id="element-426">
              <div className="bg-softblue-dark p-3 rounded-lg text-charcoal group-hover:bg-sky group-hover:text-white transition-colors shrink-0" data-id="element-427">
                <service.icon className="w-6 h-6" data-id="element-428" />
              </div>
              <div data-id="element-429">
                <h3 className="font-bold text-charcoal mb-1 group-hover:text-sky-dark transition-colors" data-id="element-430">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 leading-snug" data-id="element-431">
                  {service.desc}
                </p>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}